<template>
  <div class="main-content sn-content">
    <el-card class="box-card clearfix">
      <el-table
        :data="LarkXRCredentialList">
        <template slot="empty">
          <el-button @click="gotoAppliAdd()"
                     type="text"
                     size="small"
                     style="font-size:14px;"
                     class="pvt-color">添加托管应用
          </el-button>
        </template>
        <el-table-column label="平台密钥">
         <!-- <el-table-column
            prop="endpoint"
            label="endpoint"
          width="270">
            <template slot-scope="scope">
              <span>https://larkxrpub.pingxingyun.com/</span>
            </template>
          </el-table-column>-->

          <el-table-column
            prop="wsId"
            label="Key">
          </el-table-column>
          <el-table-column
            prop="secretKey"
            label="Secret" width="280">
            <template slot-scope="scope">
           {{   scope.row.secretKey}}
            </template>
          </el-table-column>
          <el-table-column
            prop="appEncryptFlag"
            label="是否开启托管应用加密">
            <template slot-scope="scope">
              <span v-if="scope.row.wsEncryptFlag == '1'">开启
                  <el-button @click="updateAppEncryptFlag(scope.row.wsId,'0','0')" size="mini" type="primary">关闭</el-button>
              </span>
              <span v-else>未开启
                <el-button size="mini" type="primary"  @click="updateAppEncryptFlag(scope.row.wsId,'1')">开启</el-button></span>

            </template>
          </el-table-column>
         <!-- <el-table-column
            prop="appEncryptOnetimeFlag"
            label="是否开启托管应用一次性加密">
            <template slot-scope="scope">
              <span v-if="scope.row.appEncryptOnetimeFlag == '1'">开启
              <el-button v-if="scope.row.appEncryptFlag == '1'" size="mini" type="primary"  @click="updateAppEncryptFlag(scope.row.wsId,null,'0')">关闭</el-button></span>
              <span v-else>未开启 <el-button v-if="scope.row.appEncryptFlag == '1'" size="mini"  @click="updateAppEncryptFlag(scope.row.wsId,null,'1')"
                                          type="primary">开启</el-button></span>
            </template>
          </el-table-column>-->
        </el-table-column>
        <el-table-column
          label="SDK授权加密密钥"
          prop="sdkSecret">
          <template slot-scope="scope">
            <span v-if="scope.row.sdkSecret == null || scope.row.sdkSecret == ''">
              未开启
                <el-button @click="createSdkIdSecret(scope.row.wsId)"  size="mini" type="primary">生成</el-button>
            </span>
            <span v-else>
              {{scope.row.sdkSecret}}
               <i  @click="createSdkIdSecret(scope.row.wsId)" class="el-icon-refresh"></i>
                 <el-button @click="clearSdkIdSecret(scope.row.wsId)"  size="mini" type="primary">取消</el-button>
            </span>

          </template>
        </el-table-column>
        <el-table-column
          label="VR房间口令"
          prop="vrRoomCode">
          <template slot-scope="scope">
            <span v-if="scope.row.vrRoomCode == null || scope.row.vrRoomCode == ''">
              未开启
                <el-button @click="createVrRoomCode(scope.row.wsId)"  size="mini" type="primary">生成</el-button>
            </span>
            <span v-else>
              {{scope.row.vrRoomCode}}
               <i  @click="createVrRoomCode(scope.row.wsId)" class="el-icon-refresh"></i>
            </span>

          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>

      </el-table>
      <p> <i class="el-icon-info"></i>
        <span>&nbsp;&nbsp;Key&Secret：用于二次开发的接入凭证<el-link type="primary" href="https://www.pingxingyun.com/contribute/detail?topicId=10082&categoryId=1" style="margin-top: -4px"  target="_blank">【使用规则】</el-link>，和开启托管应用加密之后的进入应用凭证。</span></p>
      <p> <i class="el-icon-info"></i>
      <span>&nbsp;&nbsp;是否开启托管应用加密：开启加密后，托管应用为私有访问权限。<el-link type="primary" href="https://www.pingxingyun.com/contribute/detail?topicId=10069&categoryId=1" target="_blank" style="margin-top: -4px" >【生成加密规则】</el-link></span></p>
      <p> <i class="el-icon-info"></i>
        <span>&nbsp;&nbsp;是否开启托管应用一次性加密：开启一次性加密后，通过appKey和appSecret生成的签名只能使用一次，不开启时，签名有效期为15分钟。</span></p>
      <p> <i class="el-icon-info"></i>
        <span>&nbsp;&nbsp;SDK授权加密密钥：是对客户端sdkId进行加解密的密码，需采用AES算法进行加密，使用sdk时需设置加密的sdkId</span></p>
      <p> <i class="el-icon-info"></i>
        <span>&nbsp;&nbsp;VR房间口令：开发者平台上传的VR应用需要下载定制客户端，输入房间口令方可使用。<el-link type="primary" href="" target="_blank" style="margin-top: -4px" >【定制客户端开发中，敬请期待~】</el-link></span></p>
    </el-card>

  </div>
</template>

<script>
  import {Message} from "element-ui";

  export default {

    data() {
      return {
        LarkXRCredentialList: [],
        userBalance: 0,
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getPersonalLarkxrClientCredential: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        this.getRequest('/uacLarkxrWorkspace/getCredentialByUserId', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.LarkXRCredentialList = [];
              this.LarkXRCredentialList.push(resp.data.result)
            } else {
              if(resp.data.message != '用户不存在')
              Message.error(resp.data.message);
            }
          }
        })
      },
      gotoAppliAdd() {
        //判断用户余额是否少于20
        if (parseInt(this.userBalance) < 20) {
          var that = this;
          this.$confirm('余额不足20，无法创建应用，请选择"去充值"。如果想获取额外支持，拨打热线电话：4006781024', '温馨提示', {
            confirmButtonText: '去充值',
            cancelButtonText: '关闭',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({path: '/account/charge'})
          }).catch(() => {

          });
        } else {
          this.$router.push({path: '/appli/add'})
        }
      },
      updateAppEncryptFlag:function (wsId,wsEncryptFlag) {
        var params = {};
        params.wsId = wsId
        if(wsEncryptFlag != null){
          params.wsEncryptFlag = wsEncryptFlag
        }
        this.postRequestJson('/uacLarkxrWorkspace/updateEncryptFlag',params ).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getPersonalLarkxrClientCredential()
            } else {
              Message.error(data.message);
            }

          }
        });
      },

      createSdkIdSecret:function (wsId) {
        var params = {};
          params.wsId = wsId
        this.postRequestJson('/uacLarkxrWorkspace/createSdkIdSecret',params ).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getPersonalLarkxrClientCredential()
            } else {
              Message.error(data.message);
            }

          }
        });
      },

      clearSdkIdSecret:function (wsId) {
        var params = {};
        params.wsId = wsId
        this.postRequestJson('/uacLarkxrWorkspace/clearSdkIdSecret',params ).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getPersonalLarkxrClientCredential()
            } else {
              Message.error(data.message);
            }

          }
        });
      },

      createVrRoomCode:function (wsId) {
        var params = {};
        params.wsId = wsId
        this.postRequestJson('/uacLarkxrWorkspace/createVrRoomCode',params ).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getPersonalLarkxrClientCredential()
            } else {
              Message.error(data.message);
            }

          }
        });
      },
    },
    mounted: function () {
      this.getPersonalLarkxrClientCredential();
    },
    beforeDestroy() {

    }
  }
</script>
